import React from "react";
import styled from "styled-components";
import ContainerDefault from "./Containers/ContainerDefault";
import Logo from "./Logo";
import { DATA_FOOTER_INFO, DATA_FOOTER_LINK } from "Data/footer";
import TextParagraph from "./Text/TextParagraph";
import BtnIcon from "./Btn/BtnIcon";
import { Link } from "react-router-dom";
import media from "Styles/media";

const Wrapper = styled.div`
	background-color: ${(props) => props.theme.color.black};
	border-top: 1px solid ${(props) => props.theme.color.gray.light};
	padding: 32px 0;
`;
const Inner = styled.div`
	display: flex;

	@media ${media.mobile} {
		flex-direction: column;
	}
`;

const LogoWrapper = styled.div`
	width: 50%;
	@media ${media.mobile} {
		margin-bottom: 24px;
	}
`;
const Menu = styled.div``;
const MenuCol = styled.div`
	color: white;
`;

const InfoList = styled(TextParagraph)`
	margin-bottom: 8px;
`;
const LinkCol = styled(MenuCol)`
	display: flex;
	margin: 16px 0;
`;

const Copyright = styled(TextParagraph)`
	color: white;
	opacity: 0.5;
`;
const Footer = () => {
	return (
		<Wrapper>
			<ContainerDefault>
				<Inner>
					<LogoWrapper>
						<Link to={"/"}>
							<Logo />
						</Link>
					</LogoWrapper>

					<Menu>
						<MenuCol>
							{DATA_FOOTER_INFO.map((str, index) => {
								return <InfoList value={str} size={14} key={index} />;
							})}
						</MenuCol>

						<LinkCol>
							{DATA_FOOTER_LINK.map((el, index) => {
								return <BtnIcon icon={el.name} onClick={() => window.open(el.value)} key={index} />;
								// return <TextParagraph value={el.name} onClick={() => window.open(el.value)} />;
							})}
						</LinkCol>

						<Copyright value={"Copyright 2020 ABCLAB All right Reserved."} size={12} />
					</Menu>
				</Inner>
			</ContainerDefault>
		</Wrapper>
	);
};

export default Footer;
